import { Box } from "@mui/material";
// import SplashPageHeader from "./header";
import ValueProp from "./valueProp";
import CreatePersonaForm from "./createPersonaForm";
import SocialProof from "./socialProof";
import ValueProp2 from "./valueProp2";
import ValueProp3 from "./valueProp3";
import ExpertAIPersonas from "./exploreAIPersonas";
import ValueProp4 from "./valueProp4";
import Faqs from "./faqs";
import Footer from "./footer";
import { useAuth } from "../../hooks/useAuth";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import LoadingPage from "../LoadingPage";
import MetaTags from "../../component/MetaTags";
import DynamicAdSense from "../memeverse/ads/DynamicAdSense";
// import { toast } from "react-toastify";


const SplashPage: React.FC = () => {
  const { authUser, authLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!authLoading && authUser) {
      // toast.error(`Redirecting... New discover page won't be accessible when logged in`)
      navigate('/ask', { replace: true })
    }
  }, [authUser, authLoading])

  if (authLoading || authUser) {
    return <LoadingPage />
  }

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        overflowY: "auto",
        maxWidth: "100%",
      }}
    >
      <MetaTags
        title='Create Your AI Persona – Scale Your Expertise | Soopra'
        description='Soopra lets experts turn their knowledge into an AI-powered persona to scale reach, engage audiences, and earn from premium content.'
        image='https://soopra.ai/images/soopra_ai_persona_home_preview.png'
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: 'center',
          py: 3,
          pt: 0,
          gap: { xs: 0, md: 1.5 },
          width: '100%',
          position: "relative",
        }}
      // maxWidth="lg"
      >
        {/* <SplashPageHeader /> */}
        <ValueProp />
        <CreatePersonaForm />
        <SocialProof />
        {process.env.REACT_APP_ENABLE_ADS === 'true' && (
          <Box width="100%" maxWidth="lg" my={4} px={2}>
            <DynamicAdSense adType='auto' />
          </Box>
        )}
        <ValueProp2 />
        <ValueProp3 />
        <ExpertAIPersonas />
        <ValueProp4 />
        <Faqs />
        <Footer />
      </Box>
    </Box>
  )
}

export default SplashPage;
